module.exports = __webpack_public_path__ + "img/57-2.b22f5464.png";